import { render, staticRenderFns } from "./MineListCardItem.vue?vue&type=template&id=806dd608&scoped=true"
import script from "./MineListCardItem.vue?vue&type=script&lang=js"
export * from "./MineListCardItem.vue?vue&type=script&lang=js"
import style0 from "./MineListCardItem.vue?vue&type=style&index=0&id=806dd608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806dd608",
  null
  
)

export default component.exports